import GroupByDropdownWithSearchQuery, {
	type JiraIssueSearchInput,
} from '@atlassian/jira-relay/src/__generated__/GroupByDropdownWithSearchQuery.graphql';
import { JSResourceForInteraction } from '@atlassian/react-async';
import { createEntryPoint } from '@atlassian/react-entrypoint';

export const groupByDropdownWithSearchEntryPoint = createEntryPoint({
	root: JSResourceForInteraction(
		() =>
			import(/* webpackChunkName: "async-issue-table-group-by-dropdown-with-search" */ './index'),
	),
	getPreloadProps: ({
		nodeId,
		issueSearchInput,
	}: {
		nodeId: string;
		issueSearchInput?: JiraIssueSearchInput;
	}) => ({
		queries: {
			groupByDropdownQuery: {
				parameters: GroupByDropdownWithSearchQuery,
				variables: {
					nodeId,
					issueSearchInput,
				},
				options: {
					fetchPolicy: 'store-or-network' as const,
				},
			},
		},
	}),
});
